enum StatusEnum {
  success = 'success',
  error = 'error',
}

export default StatusEnum
